import { InputMask } from "@react-input/mask";

function PhoneInput({ 
    className,
    placeholder,
    value,
    onChange }) {
  return (
    <InputMask
        className={className}
        placeholder={placeholder}
        mask="+351 ___ ___ ___"
        replacement={{ _: /\d/ }}
        value={value}
        onChange={onChange}
    />
  );
}

export default PhoneInput;
